export const canUserAccessKanban = (user) =>
  user?.profile === "admin" || user?.allowKanban !== "disabled";

export const canUserAccessSchedules = (user) =>
  user?.profile === "admin" || user?.allowSchedules !== "disabled";

export const getAllowedConnectionChannels = (user) => {
  if (user?.profile === "admin") {
    return ["facebook", "instagram", "whatsapp", "email"];
  }

  if (user?.allowConnections !== "enabled") {
    return [];
  }

  const channels = [];
  if (user?.allowConnectionFacebook === "enabled") channels.push("facebook");
  if (user?.allowConnectionInstagram === "enabled") channels.push("instagram");
  if (user?.allowConnectionWhatsapp === "enabled") channels.push("whatsapp");
  if (user?.allowConnectionEmail === "enabled") channels.push("email");

  // Compatibilidad con permiso anterior
  if (channels.length === 0 && user?.allowMetaConnections === "enabled") {
    return ["facebook", "instagram"];
  }

  return channels;
};

export const canUserAccessConnectionChannel = (user, channel) =>
  getAllowedConnectionChannels(user).includes(channel);

export const canUserAccessConnectionsPage = (user) =>
  user?.profile === "admin" || getAllowedConnectionChannels(user).length > 0;

export const canUserAccessEmails = (user) =>
  user?.profile === "admin" || canUserAccessConnectionChannel(user, "email");

export const getConnectionsPageRole = (user) => {
  if (user?.profile === "admin") return "admin";
  if (user?.profile === "user" && canUserAccessConnectionsPage(user)) {
    return "admin";
  }
  return user?.profile || "user";
};

export const filterConnectionsByUserPermission = (connections, user) => {
  if (!Array.isArray(connections)) return [];

  if (user?.profile === "admin") {
    return connections;
  }

  const allowed = getAllowedConnectionChannels(user);

  if (allowed.length > 0) {
    return connections.filter((connection) =>
      allowed.includes(connection?.channel)
    );
  }

  return connections.filter(
    (connection) => !["facebook", "instagram", "email"].includes(connection?.channel)
  );
};
